import { Component, Input, OnInit } from '@angular/core';
import { IQuestion } from '../../../type_definitions/datatypes';
import { DialogSize, GaMessageService, IDialog } from '../message/ga-message.service';
import { SurveyDataService } from './survey-data.service';
import { TranslationService } from '../translation/translation.service';
import { GA1Service } from '../ga1/ga1.service';
import { EVENT_CLOSE_DIALOG, IGAEvent } from '../services/ga-event.service';

@Component({
  selector: 'survey-questions-wrapper',
  template: `
    <h2 *ngIf="loading"><activity-indicator [useDefaultText]="true"></activity-indicator></h2>
    
    <div *ngIf="!loading">
      <button class="btn btn-primary" translate (click)="editSurveyQuestions()" *ngIf="!isEmbedded">GA.BUTTONS.EDIT</button>
      <survey-questions [title]="title" [questions]="questions"></survey-questions>
    </div>
  `
})
export class SurveyQuestionsWrapperComponent implements OnInit {
  @Input() public countryId:number;
  @Input() public companyId:number;
  @Input() public companyCountryId:number;
  @Input() public workflowType:string;
  @Input() public isEmbedded:boolean;

  public loading:boolean;
  public title:string;
  public questions:IQuestion[];

  private surveyMessageDialog:IDialog;

  constructor(
    private surveyDataService:SurveyDataService,
    private messageService:GaMessageService,
    private translationService:TranslationService,
    private ga1Service:GA1Service
  ) {
    /**/
  }

  public ngOnInit():void {
    this.title = this.isEmbedded ? undefined : this.translationService.instant('BPPROFILES.SURVEY.QUESTIONS.LABEL');
    this.loadSurvey();

    // register listener
    this.listen();
  }

  private listen():void {
    this.ga1Service.events.subscribe((event:IGAEvent) => {
      if (event.name === EVENT_CLOSE_DIALOG) {
        this.surveyMessageDialog?.hide();
      }
    });
  }

  private loadSurvey():void {
    this.loading = true;
    this.surveyDataService.getSurveyQuestions(this.countryId, this.workflowType, this.companyId)
      .then((questions:IQuestion[]) => {
        this.questions = questions;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public editSurveyQuestions():void {
    this.surveyMessageDialog = this.messageService.showGA1Dialog(
      this.translationService.instant('GA.BUTTONS.EDIT_LABEL', { label: 'BPPROFILES.SURVEY.ANSWERS.LABEL' }),
      this.ga1Service.getGA1Url(GA1Service.URLTYPE_SURVEY_EDIT, { companyCountryId: this.companyCountryId }),
      {
        size: DialogSize.XL,
        buttons: [
          { label: 'GA.BUTTONS.CANCEL', className: 'btn-default' }
        ]
      }
    );

    this.surveyMessageDialog.onHide.subscribe(() => {
      this.loadSurvey();
    });
  }
}